import PropTypes from 'prop-types';
import React from 'react';
import { getDashUrl } from '../utils/getDashUrl';

export const DashPass = ({ pageId, pageType }, { location }) => {
  const link = getDashUrl(pageId, pageType, location);

  if (!link) {
    return null;
  }

  return (
    <div className="dash-pass-container">
      <div className="dash-pass">
        <div className="dash-logo" />
        <span className="popover">
          <a className="button" href={link} target="_blank" rel="noopener">
            Go to Dash
          </a>
        </span>
      </div>
    </div>
  );
};

DashPass.propTypes = {
  pageId: PropTypes.number,
  pageType: PropTypes.string.isRequired
};

DashPass.contextTypes = {
  location: PropTypes.object
};

export default DashPass;
